export const API_ENDPOINT = 'https://content.dotpedia.com';
export const NANO_ENDPOINT = 'https://br.nanodots.com/nano/checkSerial/';
export const MOOSEND_API_URL = 'https://api.moosend.com/v3';
export const MOOSEND_API_KEY = '4c27b96a-d5b6-406c-9112-1acb454eea2f';
export const MOOSEND_MAILING_LIST_ID = '65948327-d083-4b95-8a44-c1bba59c5b79';

export const ASSETS_ENDPOINT = `${API_ENDPOINT}/uploads`;
